import { useTranslation } from 'next-i18next';

import Menu from '~/components/shared/Dashboard/Menu';
import { supportUrl } from '~/constants/urls';

export const UserDashboardMenu = () => {
  const { t } = useTranslation('dashboard');

  return (
    <Menu
      links={[
        {
          url: '/dashboard/settings',
          iconName: 'cog',
          text: t('dashboardNavAccountSettings'),
        },
        {
          url: supportUrl,
          iconName: 'question',
          text: t('dashboardNavHelp'),
          isExternalUrl: true,
        },
      ]}
    />
  );
};
